$( document ).ready(function() {
    $(".navbar-toggler").click(function(){
        $(".collapse").slideToggle();
         });

$(".dropdown-toggle").click(function(){
    $(this).parent().toggleClass("activenav");
});
     
$('.accordion .acc:nth-child(1) .acc-head').addClass('active');
$('.accordion .acc:nth-child(1) .acc-content').slideDown();
$('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
    $(this).siblings('.acc-content').slideUp();
    $(this).removeClass('active');
    }
    else {
    $('.acc-content').slideUp();
    $('.acc-head').removeClass('active');
    $(this).siblings('.acc-content').slideToggle();
    $(this).toggleClass('active');
    }
});  

$('.upslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow:1,
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,
    responsive: [
        {
            breakpoint:992,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              
            }
          }      
      
      
      ]
    
});


  $('.mainimage').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    adaptiveHeight: true,
    asNavFor: '.thumbimage'
  });
  $('.thumbimage').slick({
    slidesToShow:6,
    slidesToScroll: 1,
     arrows: false,
    asNavFor: '.mainimage',
    adaptiveHeight: true,
    dots: false,
    //centerMode: true,
    focusOnSelect: true,
    responsive: [
        {
            breakpoint:1200,
            settings: {
              slidesToShow:4,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          }

      ]
 
}); 


$('.seeonslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow:3,
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,
    responsive: [
        {
            breakpoint:992,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              
            }
          }      
      
      
      ]
    
});

$('.testimonialslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:2,
    slidesToScroll:1,
    autoplay: true,
    centerMode:true,
    responsive: [
      {
            breakpoint:1300,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
            }
          },
        {
            breakpoint:1200,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
              
            }
          }      
      
      
      ]
    
});


$('.beniftslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:3,
    slidesToScroll:1,
    autoplay: true,
    //centerMode:true,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint:992,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
              
            }
          }      
      
      
      ]
    
});


  $('#sl').on('change', function() {
  var v = $(this).val();  
  var price = $('option:selected',this).attr("data-price");
    $(".subscribebox .variantnewprice").html(price);
  $("#sellingplan").attr('value',v);
});


  $(".subscribebox").click(function(){
    $(this).addClass("active");
    $(".onetimebox").removeClass("active");
    var pr = $('#sl option:selected',this).attr("data-price");
    $(".subbtn b").text(pr);
    var v = $('#sl option:selected').val(); 
    $("#sellingplan").attr('value',v);
  });
  $(".onetimebox").click(function(){
    $(this).addClass("active");
    var pr = $(this).find("input").attr("data-pr");
    $(".subbtn b").text(pr);
    $(".subscribebox").removeClass("active");
    $("#sellingplan").attr('value',"");
  });


});	